import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[cDTHost]',
    standalone: false
})
export class CreateDisclosureTemplateHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) {
  }

}
